import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../utils/pickIf';

// Styles
import { colors } from '../../styles/palette';

export const useStyles = makeStyles()(
  (theme, { orderedProduct, isKiteUser, placedOrder, hasOrderLimit } = {}) => ({
    inline: { display: 'inline' },
    limitRow: {
      opacity: pickIf(hasOrderLimit, 'initial', 0),
      whiteSpace: pickIf(hasOrderLimit, 'nowrap', 'unset'),
    },
    limitRowPlaced: { display: pickIf(hasOrderLimit, 'initial', 'none') },
    accentBold: { color: colors.gilead.primary1, fontWeight: 700 },
    column: { flexDirection: 'column', display: 'flex' },
    container: {
      display: 'flex',
      '& > div:nth-child(1)': {
        flexBasis: pickIf(orderedProduct, '20%', '27%'),
      },
      '& > div:nth-child(2)': {
        flexBasis: pickIf(orderedProduct, '19%', '26%'),
      },
      '& > div:nth-child(3)': {
        flexBasis: pickIf(orderedProduct, '24%', '18%'),
      },
      '& > div:last-child': {
        alignItems: 'end',
        flexBasis: pickIf(orderedProduct, '24%', '29%'),
        paddingTop: theme.spacing(2),
      },
      [theme.breakpoints.down('lg')]: {
        '& > div:nth-child(1)': {
          alignItems: 'start !important',
          flexBasis: '60%',
        },
        '& > div:nth-child(2)': {
          alignItems: 'start !important',
          flexBasis: '40%',
        },
        '& > div:last-child': {
          paddingTop: 0,
        },
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          '& > div:nth-child(1)': {
            alignItems: 'start !important',
            flexBasis: '60%',
          },
          '& > div:nth-child(2)': {
            alignItems: 'start !important',
            flexBasis: '40%',
          },
          '& > div:last-child': {
            paddingTop: 0,
          },
        }),
      },
    },
    details: {
      color: theme.palette.darkGrey,
      display: 'flex',
      flexBasis: '30%',
      flexDirection: 'column',
      gap: theme.spacing(2),
      fontSize: 14,
      fontWeight: 600,
      [theme.breakpoints.down('lg')]: {
        gap: 3,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          gap: 3,
        }),
      },
    },
    detailsItem: {
      '& > span:first-child': {
        fontWeight: pickIf(isKiteUser, '700', '600'),
        display: 'block',
        [theme.breakpoints.down('lg')]: {
          paddingRight: theme.spacing(0.5),
          display: 'initial',
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            paddingRight: theme.spacing(0.5),
            display: 'initial',
          }),
        },
      },
      '& > span:nth-child(2)': {
        fontWeight: pickIf(isKiteUser, '400', '600'),
      },
    },
    stockItem: {
      '& > span:first-child': {
        display: 'inline',
      },
    },
    inlineItem: {
      '& > *': {
        display: 'inline',
      },
    },
    detailsItemColored: {
      color: pickIf(isKiteUser, theme.palette.primary1, theme.palette.primary2),
      fontWeight: 'bold',
      position: 'relative',
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(4),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          marginTop: theme.spacing(4),
        }),
      },
    },
    orderedProduct: {
      [theme.breakpoints.down('lg')]: {
        marginTop: placedOrder && 'auto',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          marginTop: placedOrder && 'auto',
        }),
      },
    },
    approvalInfo: {
      color: theme.palette.grey2,
      fontSize: 14,
      fontWeight: 400,
      position: 'absolute',
      left: 0,
      top: theme.spacing(3),
      width: 'max-content',
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
      },
    },
    totalItems: {
      color: theme.palette.red,
    },
  }),
);
